import { $api } from '@shared/api';

type TOpenChangeTariffPopupPayload = {
    widgetId: string;
    notMyCompany?: boolean;
};

export const openChangeTariffPopup = async ({
    widgetId,
    notMyCompany,
}: TOpenChangeTariffPopupPayload) => {
    const url =
        // @ts-ignore
        helpable.replaceUrlParameters(routable.getRoute('openChangeTariffPopupByWidget'), {
            // @ts-ignore
            _widgetId_: widgetId,
        }) + (notMyCompany ? '?notMyCompany=1' : '');

    return $api.get<string>(url, { responseType: 'text' }).then((response) => {
        // @ts-ignore
        $.modalable('open', {
            content: response.data,
        });
    });
};
